/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchDeleteActivityItem} from '../api'

export const useMutationBatchDeleteActivityItem = createReactQueryMutationHook('batchDeleteActivityItem', batchDeleteActivityItem)
